import { render, staticRenderFns } from "./appointment-success.vue?vue&type=template&id=4edf4368&scoped=true"
import script from "./appointment-success.vue?vue&type=script&lang=js"
export * from "./appointment-success.vue?vue&type=script&lang=js"
import style0 from "./appointment-success.vue?vue&type=style&index=0&id=4edf4368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edf4368",
  null
  
)

export default component.exports